import React, { useState, useEffect } from "react";
import { Table, Tag, Pagination, Spin, message, Popconfirm } from "antd";
import { useParams } from "react-router-dom";
import Sidebar from "../../../components/AdminComponents/SideNav";
import {
  ClientMenu,
  SecondaryNavClient,
  ThirdNavSub,
} from "../../../components/AdminComponents/MenuItems";
import SecondaryNav from "../../../components/AdminComponents/SecondaryNav";
import ThirdBar from "../../../components/AdminComponents/ThirdBar";
import {
  capitalizeWords,
  remainingViewportHeight,
} from "../../../components/icons/ApplicationColor";
import axiosInstance from "../../../api/Axios";
import CommonTopDetails from "../../../components/AdminComponents/CommonTopDetails";
import AddLMSPurchase from "../../../components/AdminComponents/Modals/AddLMSPurchase";
import EditableImage from "../../../components/icons/EditIcon";
import { DeleteTwoTone, FileTextOutlined } from "@ant-design/icons";

const LmsPurchaseSub = () => {
  const { id, p_id } = useParams();
  const [data, setData] = useState([]);
  const [userInfo, setUserInfo] = useState({});
  const [loading, setLoading] = useState(true);
  const [itemsLength, setItemsLength] = useState();
  const [visible, setVisible] = useState(false);
  const [messageApi, contextHolder] = message.useMessage();
  const [filterData, setFilterData] = useState({
    pageSize: 15,
    currentPage: 1,
    url: `/tnviewpurchaselist/?organization_id=${id}&org_subscription_id=${p_id}`,
    search: "",
  });
  const { pageSize, currentPage, url, search } = filterData;
  const LoadUser = async () => {
    let passUrl = url;
    let doNothing = false;
    if (search?.length > 0) {
      if (search.length > 1) {
        passUrl += `&page=${currentPage}&page_size=${pageSize}&search=${search}`;
      } else {
        doNothing = true;
      }
    } else {
      passUrl += `&page=${currentPage}&page_size=${pageSize}`;
    }
    if (!doNothing) {
      setLoading(true);
      try {
        const res = await axiosInstance.get(passUrl);
        setData(res.data.results);

        setUserInfo(res.data.summary);
        setItemsLength(res.data.count);
        setLoading(false);
        //console.log(data);
      } catch (err) {
        //console.log(err);
      }
    }
  };
  const onShowSizeChange = (current, size) => {
    setFilterData((prevData) => ({
      ...prevData,
      pageSize: size,
    }));
  };

  const onPageChange = (page, pageSize) => {
    setFilterData((prevData) => ({
      ...prevData,
      currentPage: page,
    }));
  };
  const handleSearchChange = (event) => {
    setFilterData((prevData) => ({
      ...prevData,
      search: event.target.value,
      currentPage: 1,
    }));
  };
  const CreateSuccessfull = (props) => {
    messageApi.open({
      type: "success",
      content: `New Purchase creation Successful `,
      duration: 5,
    });
    setLoading(true);
    LoadUser();
  };
  const CreateFailed = (props, err) => {
    const messageApi = message;

    const errorMessage = err?.response?.data?.detail?.non_field_errors?.[0];

    messageApi.open({
      type: "error",
      content: errorMessage || `New Purchase creation failed ${props}.`,
      duration: 5,
    });
  };
  useEffect(() => {
    LoadUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filterData]);
  // Table columns
  const showModal = () => {
    setVisible(true);
  };

  const handleCancel = () => {
    setVisible(false);
  };
  const columns = [
    {
      title: "Purchased By",
      dataIndex: "purchase_created_by",
      key: "purchase_created_by",
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 400,
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (amount) => `$ ${amount.toLocaleString()}`, // Format amount with dollar sign and commas
    },
    {
      title: "No. of Views",
      dataIndex: "views",
      key: "views",
    },
    {
      title: "Status",
      dataIndex: "purchase_status",
      key: "purchase_status",
      render: (status) => {
        let color = "";
        switch (status) {
          case "Pending":
            color = "orange";
            break;
          case "Failed":
            color = "red";
            break;
          case "In Progress":
            color = "blue";
            break;
          case "Success":
            color = "green";
            break;
          default:
            color = "gray";
        }
        return <Tag color={color}>{status}</Tag>;
      },
    },
    {
      title: "Uploaded File",
      dataIndex: "purchases_doc",
      key: "purchases_doc",
      align: "center",
      render: (purchased_doc) => {
        if (purchased_doc) {
          return (
            <a
              href={purchased_doc}
              download
              target="_blank"
              rel="noopener noreferrer"
            >
              <FileTextOutlined
                style={{ fontSize: "2rem", cursor: "pointer" }}
              />
            </a>
          );
        }
        return null;
      },
    },
    {
      title: "Purchased At",
      dataIndex: "purchased_at",
      key: "purchased_at",
    },
    {
      title: capitalizeWords("ACTIONS"),
      key: "actions",
      width: 100,
      align: "center",
      render: (text, record) => {
        return (
          <>
            <div style={{ display: "flex", justifyContent: "center" }}>
              <EditableImage handleRowClick={() => {}} recordId={record} />
              {false && (
                <Popconfirm
                  title="Archive Location"
                  description=" "
                  onConfirm={() => {}}
                  // onCancel={cancel}
                  okText="Yes"
                  cancelText="No"
                  placement="left"
                >
                  <DeleteTwoTone
                    style={{
                      cursor: "pointer",
                      fontSize: "1.8rem",
                      marginLeft: "0.9rem",
                    }}
                    // onClick={() => {
                    //   handleDelete(record);
                    // }}
                    title="delete"
                    twoToneColor="#eb2f96"
                  />
                </Popconfirm>
              )}
            </div>
          </>
        );
      },
    },
  ];

  return (
    <Sidebar props={ClientMenu}>
      <SecondaryNav id={parseInt(id)} menuItems={SecondaryNavClient} />
      <ThirdBar menuItems={ThirdNavSub(id, p_id, true)} />
      {contextHolder}
      <CommonTopDetails
        title="LMS Views Purchase List"
        titleSuffix={`Consumed View Count : ${
          userInfo?.consumed_view_count || 0
        } | Total View Count : ${userInfo?.purchased_view_count || 0}`}
        searchPlaceholder="Search by..."
        searchAction={handleSearchChange}
        marginPass="15px"
        showAddButton={true}
        addButtonProps={{
          modalType: "PopUP",
          modalProps: showModal,
        }}
      />
      <Spin spinning={loading}>
        <Table
          columns={columns}
          dataSource={data}
          size="small"
          rowKey="id"
          bordered
          scroll={{
            x: 1000,
            y: `${remainingViewportHeight(24)}px`,
          }}
          pagination={false}
          className="table-container"
          style={{ margin: "1rem" }}
        />
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            padding: "1rem",
          }}
        >
          <Pagination
            size="small"
            showSizeChanger
            onShowSizeChange={onShowSizeChange}
            onChange={onPageChange}
            pageSizeOptions={["10", "15", "30", "50", "100"]}
            showQuickJumper
            current={currentPage}
            defaultPageSize={pageSize}
            total={itemsLength}
          />
        </div>
      </Spin>
      <AddLMSPurchase
        visible={visible}
        onCancel={handleCancel}
        org_id={id}
        org_sub_id={p_id}
        CreateSuccessfull={CreateSuccessfull}
        CreateFailed={CreateFailed}
      />
    </Sidebar>
  );
};

export default LmsPurchaseSub;
